import React from 'react';
import PropTypes from 'prop-types';

import { Chip } from 'components/Chip';
import { Grid } from 'components/Grid';
import { Heading, HeadingBoundary } from 'components/Heading';
import { Image } from 'components/Image';
import { Link } from 'components/Link';
import { Rating } from 'components/Rating';
import { cx } from 'utility';
import * as styles from './BookList.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
};

const defaultProps = {
    className: '',
    items: [],
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['bookList'],
    );

    return classes || undefined;
}

function BookList({
    className,
    items,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <Grid>
                <div className={styles['container']}>
                    {items.map(({ book_category, book_image, book_rating, book_title, book_url }, index) => {
                        const category = book_category?.text;
                        const image = book_image;
                        const rating = book_rating;
                        const title = book_title?.text;
                        const url = book_url;

                        return (
                            <div className={styles['item']} key={`book-list-item-${index}`}>
                                <HeadingBoundary>
                                    <div className={styles['imageContainer']}>
                                        {image && (
                                            <Image
                                                className={styles['image']}
                                                image={image}
                                            />
                                        )}
                                    </div>
                                    <div className={styles['contentContainer']}>
                                        {title && (
                                            <Heading
                                                className={styles['title']}
                                                size={3}
                                            >
                                                <Link className={styles['titleLink']} emphasis="high" to={url}>{title}</Link>
                                            </Heading>
                                        )}
                                        {rating && (
                                            <Rating
                                                className={styles['rating']}
                                                rating={rating}
                                            />
                                        )}
                                        {category && (
                                            <Chip
                                                className={styles['chip']}
                                            >
                                                {category}
                                            </Chip>
                                        )}
                                    </div>
                                </HeadingBoundary>
                            </div>
                        );
                    })}
                </div>
            </Grid>
        </div>
    );
}

BookList.propTypes = propTypes;
BookList.defaultProps = defaultProps;

export { BookList };
